import { render } from "./ArticleSummaryView.vue?vue&type=template&id=45c9c518"
import script from "./ArticleSummaryView.vue?vue&type=script&lang=js"
export * from "./ArticleSummaryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__